import React, {Component} from "react";

import {NavLink} from "react-router-dom";

class AssignHomeSessionDialog extends Component {
    render() {
        let {show, player, hide_func} = this.props;


        if (show) {
            return (
                <div className='assign_home_session_dialog_container'>
                    <div className='assign_home_session_modal' onClick={hide_func}></div>
                    <div className='assign_home_session_dialog'>
                        <div className='assign_home_session_dialog_title'>Add Home Session</div>
                        <button className='hide_assign_home_session_dialog' onClick={hide_func}><i className='fa fa-times'></i></button>

                        <NavLink to={{
                            pathname: `/player/${player.id}/sessionBank`,                            
                            player: player
                        }}>
                            <button className='assign_home_session_button'>Assign Existing Session</button>
                        </NavLink>
                        <NavLink to={{
                            pathname: `/player/${player.id}/gameSession`,    
                            returnRoute:  window.location.pathname,                       
                            player: player
                        }}>
                            <button className='assign_home_session_button'>Create a New Session</button>
                        </NavLink>
                    </div>
                </div>
            ) 
        }
        else {
            return (<div></div>);
        }
    }
}


export default AssignHomeSessionDialog;


// WEBPACK FOOTER //
// ./src/components/containers/home-play/assign-home-session-dialog.js